<template>
    <div>
        <div class="nos1-1">历史记录/未还详情</div>
        <div class="nos5">
            <div class="nos6">用户信息</div>
            <div class="nos7">
                <div class="nos7-1">用户名称：{{name}}</div>
                <div class="nos7-1" v-if="orgname != null">组织架构：{{orgname}}-{{orgname2}}</div>
                <div class="nos7-1" v-if="orgname == null">组织架构：</div>
                <div class="nos7-1">未归还总数量：{{notreturnnum}}</div>
            </div>
            <div class="nos7">
                <div class="nos7-1">用户编号：{{code}}</div>
                <div class="nos7-1"></div>
                <div class="nos7-1">状态：{{state}}</div>
            </div>
        </div>
        <div class="nos8">
            <div class="nos6">未归还刀具记录</div>
            <div class="nos9">
                <Table border ref="selection" :columns="columns7" :data="detail" :loading="loading">
                    <!-- <template slot-scope="{ row,index }" slot="action">
                        <Button size="small" style="margin-right: 5px;border: none;color: #7AD1F9;" @click="shezhi(row,index)">设置数量</Button> 
                    </template> -->
                </Table>
            </div>
        </div>
        <div class="nos10" style="border-bottom: none;margin-top: 5px;">
            <Page :total="total" :page-size="7" @on-change="toPage"/>
        </div>
        <div class="nos11" @click="returns">返回上一步</div>
    </div>
</template>

<script>
import http from '@/api/retrieve';
    export default {
        data(){
            return{
                order:{},
                notreturnnum:'',
                state:'',
                name:'',
                orgname:'',
                orgname2:'',
                code:'',
                loading:false,
                total:1,
                columns7:[
                    {
                        title: '刀具名称',
                        width: 200,
                        align: 'center',
                        key: 'goodsname'
                    },
                    {
                        title: '刀具编码',
                        width: 200,
                        align: 'center',
                        key: 'goodscode'
                    },
                    {
                        title: '刀具型号',
                        width: 200,
                        align: 'center',
                        key: 'goodsspecs'
                    },
                    {
                        title: '单位',
                        width: 150,
                        align: 'center',
                        key: 'goodsunit'
                    },
                    {
                        title: '未归还数量',
                        width: 150,
                        align: 'center',
                        key: 'notreturnnum'
                    },
                    {
                        title: '订单编号',
                        width: 200,
                        align: 'center',
                        key: 'ordercode'
                    },
                    {
                        title: '创建时间',
                        width: 200,
                        align: 'center',
                        key: 'ctime'
                    },
                ],
                detail:[],
                id:'',
                user:'',
                page:1,
                pageSize:7 
            }
        },
        mounted(){
            this.user = JSON.parse(sessionStorage.getItem('user'));
            this.id = this.$route.query.id
            this.notreturnnum = this.$route.query.notreturnnum
            this.state = this.$route.query.state
            this.name = this.$route.query.name
            this.orgname = this.$route.query.orgname
            console.log(this.orgname,'this.orgname')
            this.orgname2 = this.$route.query.orgname2
            this.code = this.$route.query.code
            this.loading = true;
            let data = {
                companyid:this.user.companyId,
                userid:this.id,
                keyword:'',
                page:this.page,
                pageSize:this.pageSize,
            };
            http.getnotreturned(data).then(res=>{
                this.detail = res.data.dataList
                this.total = res.data.totalNum
                this.loading = false;
            })
        },
        methods:{
            toPage(e){
                this.loading = true;
                let data = {
                    companyid:this.user.companyId,
                    userid:this.id,
                    keyword:'',
                    page:e,
                    pageSize:this.pageSize,
                };
                http.getnotreturned(data).then(res=>{
                    this.detail = res.data.dataList
                    this.total = res.data.totalNum
                    this.loading = false;
                })
            },
            returns(){
                this.$router.back()
            },
        }
    }
</script>

<style scoped>
@import 'notReturndetail.css'
</style>